import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "./Button";
import Modal from "./CustomModal";

const PassingCriteriaModal = ({ open, onClose, onSubmit, loading = false }) => {
    const [passingCriteria, setPassingCriteria] = useState("");
    const [receiverEmail, setReceiverEmail] = useState("");
    const [errors, setErrors] = useState({});

    const validateForm = () => {
        const newErrors = {};

        if (!passingCriteria || isNaN(passingCriteria) || passingCriteria <= 0) {
            newErrors.passingCriteria = "Please enter a valid number for passing criteria";
        }

        if (!receiverEmail) {
            newErrors.receiverEmail = "Receiver email is required";
        } else if (!/^\S+@\S+\.\S+$/.test(receiverEmail)) {
            newErrors.receiverEmail = "Please enter a valid email address";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = () => {
        if (validateForm()) {
            onSubmit({
                passingCriteria: Number(passingCriteria),
                receiverEmail: receiverEmail.trim()
            });
        }
    };

    const handleClose = () => {
        setPassingCriteria("");
        setReceiverEmail("");
        setErrors({});
        onClose();
    };

    return (
        <Modal
            open={open}
            onClose={handleClose}
            center
            classNames={{ modal: "passingCriteriaModal" }}
        >
            <div style={{ padding: "20px", width: "400px" }}>
                <h3 style={{
                    marginBottom: "20px",
                    fontFamily: "Poppins",
                    fontSize: "20px",
                    fontWeight: "600"
                }}>
                    Set Passing Criteria
                </h3>

                <div style={{ marginBottom: "20px" }}>
                    <label style={{
                        display: "block",
                        marginBottom: "8px",
                        fontWeight: "500",
                        fontSize: "14px"
                    }}>
                        Passing Criteria (Number) *
                    </label>
                    <input
                        type="number"
                        value={passingCriteria}
                        onChange={(e) => setPassingCriteria(e.target.value)}
                        placeholder="Enter passing criteria number"
                        style={{
                            width: "100%",
                            padding: "10px",
                            border: errors.passingCriteria ? "1px solid #e74c3c" : "1px solid #ddd",
                            borderRadius: "5px",
                            fontSize: "14px",
                            boxSizing: "border-box"
                        }}
                    />
                    {errors.passingCriteria && (
                        <span style={{ color: "#e74c3c", fontSize: "12px" }}>
                            {errors.passingCriteria}
                        </span>
                    )}
                </div>

                <div style={{ marginBottom: "30px" }}>
                    <label style={{
                        display: "block",
                        marginBottom: "8px",
                        fontWeight: "500",
                        fontSize: "14px"
                    }}>
                        Receiver Email *
                    </label>
                    <input
                        type="email"
                        value={receiverEmail}
                        onChange={(e) => setReceiverEmail(e.target.value)}
                        placeholder="Enter receiver email address"
                        style={{
                            width: "100%",
                            padding: "10px",
                            border: errors.receiverEmail ? "1px solid #e74c3c" : "1px solid #ddd",
                            borderRadius: "5px",
                            fontSize: "14px",
                            boxSizing: "border-box"
                        }}
                    />
                    {errors.receiverEmail && (
                        <span style={{ color: "#e74c3c", fontSize: "12px" }}>
                            {errors.receiverEmail}
                        </span>
                    )}
                </div>

                <div style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px"
                }}>
                    <Button
                        style={{
                            background: "#6c757d",
                            fontWeight: "bold",
                            fontFamily: "Poppins",
                            letterSpacing: "0.01em",
                            borderRadius: "25px",
                            padding: "8px 20px",
                            fontSize: "14px",
                        }}
                        size="small"
                        variant="contained"
                        onClick={handleClose}
                        disabled={loading}
                    >
                        Cancel
                    </Button>
                    <Button
                        style={{
                            background: "#479BD2",
                            fontWeight: "bold",
                            fontFamily: "Poppins",
                            letterSpacing: "0.01em",
                            borderRadius: "25px",
                            padding: "8px 20px",
                            fontSize: "14px",
                        }}
                        size="small"
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={loading}
                    >
                        {loading ? "Sending..." : "Submit"}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

PassingCriteriaModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    loading: PropTypes.bool,
};

export default PassingCriteriaModal;